// extracted by mini-css-extract-plugin
export default {"project-section":"Projects_project-section__I1eWv","heading":"Projects_heading__3rLyj","blink":"Projects_blink__rCN9q","projects":"Projects_projects__-0W38"};